import { call, put, SagaReturnType, takeLatest } from 'redux-saga/effects';
import { TherapistAction } from 'src/redux/actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

const {
  UPDATE_TIME_BASIS_REQUEST,
  UPDATE_TIME_BASIS_SUCCESS,
  UPDATE_TIME_BASIS_FAILURE,
  UPDATE_TIME_BASIS_LOADING,
} = TherapistAction;

function* updateTimeBasis(action: any): SagaReturnType<any> {
  try {
    yield put({ type: UPDATE_TIME_BASIS_LOADING });
    const response = yield call(therapistSchedulingServices.updateTimeBasis, action.payload);
    if (response?.status === 200 || response?.status === 204) {
      yield put({ type: UPDATE_TIME_BASIS_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: UPDATE_TIME_BASIS_FAILURE, payload: error });
  }
}

function* updateTimeBasisSaga() {
  yield takeLatest(UPDATE_TIME_BASIS_REQUEST, updateTimeBasis);
}

export default updateTimeBasisSaga;
